import Vue from 'vue'
import Router from 'vue-router'
import * as Sentry from "@sentry/vue"
import { v4 as uuidv4 } from 'uuid'

const router = new Router({
    mode: 'history',
    base: '/app',
    routes: [
        //DETACHED
        {
            path: '/login',
            name: 'login',
            component: () => import('@cc/Auth/Login.vue'),
            meta: {title: 'Login', authExempt: true}
        },
        {
            path: '/external/reports/email_report_periodic',
            name: 'email_report_periodic',
            component: () => import('@cc/externals/report/EmailReportPeriodic.vue'),
            meta: {title: 'Email Report', authExempt: true}
        },
        {
            path: '/oauth/authorize',
            name: 'oauth_authorize',
            component: () => import('@cc/OAuth/OAuthAuthorize.vue'),
            meta: {title: 'Authorize Application'}
        },
        //COMMON
        {
            path: '/:module?/email/inbox',
            name: 'email_inbox',
            component: () => import('@cc/common/EmailInbox.vue'),
            meta: {title: 'Email Inbox'}
        },
        {
            path: '/:module?/email/detail/:id?',
            name: 'email_detail',
            component: () => import('@cc/common/EmailDetail.vue'),
            meta: {title: 'Email Detail'}
        },
        {
            path: '/:module?/test',
            name: 'Test',
            component: () => import('@cc/Test.vue'),
            meta: {title: 'Test'}
        },
        {
            path: '/:module?/dashboard/:id?',
            name: 'dashboard',
            component: () => import('@cc/Dashboard.vue'),
            meta: {title: 'Dashboard'}
        },
        {
            path: '/:module?/403',
            name: '403',
            component: () => import('@cc/Forbidden.vue'),
            meta: {title: 'Access Denied'}
        },

        {
            path: '/:module?/presets/company_types/:type',
            name: 'company_subtypes',
            component: () => import('@cc/presets/CompanySubTypes.vue'),
            // meta: {module: 'project'}
        },
        {
            path: '/:module?/presets/company_types',
            name: 'company_types',
            component: () => import('@cc/presets/CompanyTypes.vue'),
            // meta: {module: 'project'}
        },
        {
            path: '/:module?/presets/sectors/:sector',
            name: 'sub_sectors',
            component: () => import('@cc/presets/SubSectors.vue'),
            // meta: {module: 'project'}
        },
        {
            path: '/:module?/presets/sectors',
            name: 'sectors',
            component: () => import('@cc/presets/Sectors.vue'),
            // meta: {module: 'project'}
        },
        {
            path: '/:module?/presets/sc/transaction_type',
            name: 'transaction_types',
            component: () => import('@cc/presets/TrxTypes.vue'),
            // meta: {module: 'project'}
        },
        {
            path: '/:module?/presets/sc/project_status',
            name: 'project_status',
            component: () => import('@cc/presets/ProjectStatuses.vue'),
            // meta: {module: 'project'}
        },
        {
            path: '/:module?/presets/sc/job_title',
            name: 'job_title',
            component: () => import('@cc/presets/JobTitles.vue'),
            meta: {
                title: 'Employee Titles',
                // module: 'project'
            }
        },

        {
            path: '/:module?/presets/sc/employee-sector',
            name: 'employee_sector',
            component: () => import('@cc/presets/EmployeeSector.vue'),
            meta: {
                title: 'Employee Sector',
                // module: 'project'
            }
        },
        {
            path: '/:module?/presets/sc/:type',
            name: 'presets_sc',
            component: () => import('@cc/presets/CorporateStatuses.vue'),
            // meta: {module: 'project'}
        },
        {
            path: '/:module?/presets/own/:type',
            name: 'presets_own',
            component: () => import('@cc/presets/Ownerships.vue'),
            // meta: {module: 'project'}
        },
        {
            path: '/:module?/presets/ps/:type/:trx?',
            name: 'presets_ps',
            component: () => import('@cc/presets/ProjectStages.vue'),
            // meta: {module: 'project'}
        },

        {
            path: '/:module?/presets/currencies',
            name: 'currencies',
            component: () => import('@cc/presets/Currencies.vue'),
            meta: {
                title: 'Currency',
                // module: 'project'
            }
        },
        {
            path: '/:module?/presets/document-types',
            name: 'document_types',
            component: () => import('@cc/presets/DocumentTypes.vue'),
            meta: {
                title: 'Document Types',
                // module: 'project'
            }
        },

        {
            path: '/:module?/authorization/groups',
            name: 'groups',
            component: () => import('@cc/common/Groups.vue'),
            meta: {title: 'Groups'}
        },
        {
            path: '/:module?/authorization/permissions/group/',
            name: 'group_permission_details',
            component: () => import('@cc/common/ViewPermissionByGroup.vue'),
            meta: {title: 'Group permissions'}
        },
        {
            path: '/:module?/authorization/permissions/user/:id?',
            name: 'user_permission_details',
            component: () => import('@cc/common/ViewPermissionByUser.vue'),
            meta: {title: 'User permissions'}
        },
        {
            path: '/:module?/authorization/sub-groups',
            name: 'sub_groups',
            component: () => import('@cc/common/SubGroups.vue'),
            meta: {title: 'Subgroups'}
        },
        {
            path: '/:module?/authorization/sub-groups/:id/users/',
            name: 'view_users_by_subgroup',
            component: () => import('@cc/common/UsersBySubGroup.vue'),
            meta: {title: 'Users by subgroup'}
        },
        {
            path: '/:module?/authorization/view_group/:id',
            name: 'view_group',
            component: () => import('@cc/common/ViewGroup.vue'),
            meta: {title: 'View Group'}
        },
        // {
        //     path: '/:module?/authorization/permissions',
        //     component: () => import('@cc/common/Permissions.vue'),
        //     meta: {title: 'Permissions'}
        // },

        {
            path: '/:module?/team/invites',
            name: 'invites',
            component: () => import('@cc/common/Invites.vue'),
            meta: {
                title: 'Invites',
                resource: 'Settings',
                action: 'invite-users',
            }
        },

        {
            path: '/:module?/team/users',
            name: 'users',
            component: () => import('@cc/common/Users.vue'),
            meta: {
                title: 'Users',
                resource: 'Settings',
                action: 'view-users',
            }
        },
        //{path: '//:module?team/users/create', name: 'user_create', component: () => import('@cc/common/UserCreate.vue'), meta: {title: 'Create User'}},
        {
            path: '/:module?/team/users/edit/:id',
            name: 'user_edit',
            component: () => import('@cc/common/UserEdit.vue'),
            meta: {
                title: 'Edit User',
                resource: 'Settings',
                action: 'view-users',
            }
        },
        {
            path: '/:module?/team/users/projects/:id',
            name: 'user_projects',
            component: () => import('@cc/common/UserProjects.vue'),
            meta: {
                title: 'User Projects',
                resource: 'Settings',
                action: 'view-users',
            }
        },
        
        {
            path: '/:module?/team/teams',
            name: 'teams',
            component: () => import('@cc/common/Teams.vue'),
            meta: {
                title: 'Teams',
                resource: 'Settings',
                action: 'view-users',
            }
        },

        {
            path: '/:module?/team/user/my-followings',
            name: 'my_followings',
            component: () => import('@cc/common/MyFollowings.vue'),
            meta: {title: 'My Followings'}
        },

        // Author:Kiron
        {
            path: '/:module?/team/user/profile',
            name: 'user_profile',
            component: () => import('@cc/common/UserProfile.vue'),
            meta: {title: 'User Profile'}
        },
        {
            path: '/:module?/team/user/edit-profile',
            name: 'edit_profile',
            component: () => import('@cc/common/EditProfile.vue'),
            meta: {title: 'Edit Profile'}
        },
        {
            path: '/:module?/team/user/change-password',
            name: 'change_password',
            component: () => import('@cc/common/ChangePassword3.vue'),
            meta: {title: 'Change Password'}
        },
        {
            path: '/:module?/team/user/project-permissions',
            name: 'project_permissions',
            component: () => import('@cc/common/ProjectPermissions.vue'),
            meta: {title: 'Project Permissions', module: 'project'}
        },
        // {
        //     path: '/:module?/clients/group-permission',
        //     name: 'group_permission',
        //     component: () => import('@cc/clients/GroupPermission.vue'),
        //     meta: {title: 'Group Permission'}
        // },
        


        //MASTER MODULE
        {
            path: '/clients',
            name: 'clients',
            component: () => import('@cc/common/Clients.vue'),
            meta: {title: 'Clients'}
        },
        {
            path: '/clients/create',
            name: 'clients_create',
            component: () => import('@cc/common/ClientCreate.vue'),
            meta: {title: 'Create Client'}
        },
        {
            path: '/clients/edit/:id',
            name: 'clients_edit',
            component: () => import('@cc/common/ClientCreate.vue'),
            meta: {title: 'Edit Client'}
        },

        //TENANT
        //MODULE projects
        {
            path: '/:module?/clients/framework_setup',
            name: 'framework_setup',
            component: () => import('@cc/clients/FrameworkSetup.vue'),
            meta: {title: 'Framework Setup'}
        },

        {
            path: '/project/projects',
            name: 'projects',
            component: () => import('@cc/clients/projects/Projects.vue'),
            meta: {title: 'Projects', module: 'project'}
        },
        {
            path: '/project/projects/create',
            name: 'project_create',
            component: () => import('@cc/clients/projects/ProjectCreate.vue'),
            meta: {
                title: 'Create Project',
                resource: 'Projects',
                action: 'create-project',
                module: 'project'
            }
        },
        {
            path: '/project/projects/edit/:id',
            name: 'project_edit',
            component: () => import('@cc/clients/projects/ProjectCreate.vue'),
            meta: {title: 'Edit Project', module: 'project'}
        },
        {
            path: '/project/project/details/:id',
            name: 'project_details',
            component: () => import('@cc/clients/projects/ProjectDetails.vue'),
            meta: {title: 'Project', module: 'project'}
        },
        {
            path: '/project/project/buyer-review/:id',
            name: 'buyer_review',
            component: () => import('@cc/clients/projects/BuyerReview.vue'),
            meta: {title: 'Project Buyer Review', module: 'project'}
        },
        {
            path: '/project/project/buyer_report/:id?',
            name: 'buyer_report',
            component: () => import('@cc/clients/projects/BuyerReport.vue'),
            meta: {title: 'Buyer Report', module: 'project'}
        },
        {
            path: '/project/project/buyer_report/',
            name: 'buyer_report_',
            component: () => import('@cc/clients/projects/BuyerReport.vue'),
            meta: {title: 'Buyer Report', module: 'project'}
        },
        // Buyer routes
        {
            path: '/project/:type(project|pitchbook)/:id/buyer-previous-projects',
            name: 'buyer_previous_projects',
            component: () => import('@cc/clients/projects/BuyerPreviousProjects.vue'),
            meta: {title: 'Buyer Previous Projects', module: 'project'}
        },
        {
            path: '/project/:type(project|pitchbook)/:id/import-buyers',
            name: 'buyer_import',
            component: () => import('@cc/clients/projects/ImportCSV.vue'),
            meta: {title: 'Import Buyers', module: 'project'}
        },
        {
            path: '/project/:type(project|pitchbook)/:id/business-description',
            name: 'business_description',
            component: () => import('@cc/clients/projects/BusinessDescription.vue'),
            meta: {title: 'Business Description', module: 'project'}
        },


        //Author:Kiron
        {
            path: '/project/projects/all-projects/:mode(card|card-min|list)?',
            name: 'all_projects',
            component: () => import('@cc/clients/projects/AllProjects.vue'),
            meta: {title: 'All Projects', module: 'project'}
        },
        {
            path: '/project/projects/my-projects',
            name: 'my_projects',
            component: () => import('@cc/clients/projects/MyProjects.vue'),
            meta: {title: 'My Projects', module: 'project'}
        },
        {
            path: '/project/projects/projects-summary',
            name: 'projects_summary',
            component: () => import('@cc/clients/projects/ProjectStageHistory.vue'),
            meta: {title: 'Projects Summary', module: 'project'}
        },
        {
            path: '/project/projects/project',
            name: 'single_project',
            component: () => import('@cc/clients/projects/Project.vue'),
            meta: {title: 'Single Project', module: 'project'}
        },
        // private equity

        {
            path: '/project/private-equity',
            name: 'private_equity',
            component: () => import('@cc/clients/companies/PrivateEquity.vue'),
            meta: {title: 'Private Equity', module: 'project'}
        },

        {
            path: '/project/private-equity/details/:id',
            name: 'private_equity_activity_details',
            component: () => import('@cc/clients/companies/PrivateEquityActivityDetails.vue'),
            meta: {title: 'Private Equity Activity Details', module: 'project'}
        },

        {
            path: '/project/private-equity/activity',
            name: 'private_equity_activity',
            component: () => import('@cc/clients/companies/PrivateEquityActivity.vue'),
            meta: {title: 'Private Equity Activity', module: 'project'}
        },

        {
            path: '/project/private-equity/deals',
            name: 'private_equity_deals',
            component: () => import('@cc/clients/pe_deals/PrivateEquity.vue'),
            meta: {title: 'Private Equity Deals', module: 'project'}
        },

        {
            path: '/project/private-equity/deals/by-project',
            name: 'project_private_equity_deals',
            component: () => import('@cc/clients/pe_deals/ProjectPE.vue'),
            meta: {title: 'Project Private Equity Deals', module: 'project'}
        },

        // private equity crm
        {
            path: '/crm/private-equity',
            name: 'crm_private_equity',
            component: () => import('@cc/clients/companies/PrivateEquity.vue'),
            meta: {title: 'Private Equity', module: 'crm'}
        },

        {
            path: '/crm/private-equity/details/:id',
            name: 'crm_private_equity_activity_details',
            component: () => import('@cc/clients/companies/PrivateEquityActivityDetails.vue'),
            meta: {title: 'Private Equity Activity Details', module: 'crm'}
        },

        {
            path: '/crm/private-equity/activity',
            name: 'crm_private_equity_activity',
            component: () => import('@cc/clients/companies/PrivateEquityActivity.vue'),
            meta: {title: 'Private Equity Activity', module: 'crm'}
        },

        // PitchBook
        {
            path: '/project/project/review-of-buyers-for-pitchbook',
            name: 'review_of_buyers_for_pitchbook',
            component: () => import('@cc/clients/pitchbooks/ReviewBuyersPitchbook.vue'),
            meta: {title: 'Review of Buyers for Pitchbook', module: 'project'}
        },

        {
            path: '/:module(project|crm)/companies',
            name: 'companies',
            // component: () => import('@cc/clients/companies/Companies.vue'),
            component: () => import('@cc/modules/crm/company/Companies.vue'),
            meta: {title: 'Companies'}
        },
        {
            path: '/project/pitchbooks',
            name: 'pitchbooks',
            component: () => import('@cc/clients/pitchbooks/Pitchbooks.vue'),
            meta: {title: 'Pitchbooks', module: 'project'}
        },
        {
            path: '/project/pitchbooks/list',
            name: 'pitchbooks_list',
            component: () => import('@cc/clients/pitchbooks/PitchBookList.vue'),
            meta: {title: 'Pitchbooks', module: 'project'}
        },
        {
            path: '/project/pitchbooks/review/:id',
            name: 'pitchbook_review',
            component: () => import('@cc/clients/pitchbooks/ReviewBuyersPitchbook.vue'),
            meta: {title: 'Pitchbook Review', module: 'project'}
        },
        {
            path: '/:module(project|crm)/companies/details/:id',
            name: 'company_details',
            component: () => import('@cc/clients/companies/CompanyOverview.vue'),
            meta: {title: 'Company Overview'}
        },
        {
            path: '/:module(project|crm)/companies/overview/',
            name: 'company_overview_for_else',
            component: () => import('@cc/clients/companies/CompanyOverviewForElse.vue'),
            meta: {title: 'Company Overview'}
        },
        {
            path: '/:module(project|crm)/stock-companies/:mode(fmp|finder)?',
            name: 'stock_companies',
            component: () => import('@cc/clients/companies/FmpCompanies.vue'),
            meta: {title: 'FMP Stock Companies'}
        },
        {
            path: '/project/people',
            name: 'project_people',
            // component: () => import('@cc/clients/companies/Contacts.vue'),
            component: () => import('@cc/modules/crm/company/People.vue'),
            meta: {title: 'People', module: 'project'}
        },
        {
            path: '/:module(project|crm)/people/tracker',
            name: 'people_tracker',
            component: () => import('@cc/modules/crm/company/TrackPeople.vue'),
            meta: {title: 'Recent Job Changes'}
        },

        // {
        //     path: '/project/companies/create',
        //     name: 'company_create',
        //     component: () => import('@cc/clients/companies/CompanyCreate.vue'),
        //     meta: {title: 'Create Company', module: 'project'}
        // },
        {
            path: '/project/companies/edit/:id',
            name: 'company_edit',
            component: () => import('@cc/clients/companies/CompanyCreate.vue'),
            meta: {title: 'Edit Company', module: 'project'}
        },
        {
            path: '/project/companies/settings/:id',
            name: 'company_settings',
            component: () => import('@cc/clients/companies/CompanySettings.vue'),
            meta: {title: 'Edit Company', module: 'project'}
        },
        {
            path: '/project/prepreset',
            name: 'prepreset',
            component: () => import('@cc/presets/PrePreset.vue'),
            meta: {title: 'Pre-preset', module: 'project'}
        },


        {
            path: '/project/project/distribution',
            name: 'distribution_',
            component: () => import('@cc/clients/projects/distributions/DistributionG.vue'),
            meta: {title: 'Distribution', module: 'project'}
        },
        {
            path: '/project/project/:id/templates',
            name: 'templates_',
            component: () => import('@cc/clients/projects/distributions/DistributionTemplatesG.vue'),
            meta: {title: 'Distribution Templates', module: 'project'}
        },
        {
            path: '/project/project/:id/distribution-files',
            name: 'distribution_files_',
            component: () => import('@cc/clients/projects/distributions/DistributionFilesG.vue'),
            meta: {title: 'Distribution Files', module: 'project'}
        },
        {
            path: '/project/project/:id/distribution',
            name: 'distribution',
            component: () => import('@cc/clients/projects/distributions/Distribution.vue'),
            meta: {title: 'Distribution', module: 'project'}
        },
        {
            path: '/project/project/:id/templates',
            name: 'templates',
            component: () => import('@cc/clients/projects/distributions/DistributionTemplates.vue'),
            meta: {title: 'Distribution Templates', module: 'project'}
        },
        {
            path: '/project/project/:id/distribution-files',
            name: 'distribution_files',
            component: () => import('@cc/clients/projects/distributions/DistributionFiles.vue'),
            meta: {title: 'Distribution Files', module: 'project'}
        },
        {
            path: '/project/reports/report-pages',
            name: 'report_pages',
            component: () => import('@cc/clients/reports/ReportPages.vue'),
            meta: {
                title: 'Report Pages',
                module: 'project'
            }
        },
        {
            path: '/project/reports/email-report-settings',
            name: 'email_report_settings',
            component: () => import('@cc/clients/reports/EmailReportSettings.vue'),
            meta: {
                title: 'Email Report Settings',
                module: 'project'
            }
        },
        {
            path: '/project/reports/report-list',
            name: 'report_list',
            component: () => import('@cc/clients/reports/ReportList.vue'),
            meta: {
                title: 'Report List',
                module: 'project'
            }
        },
        {
            path: '/project/reports/new-deal-performance/edit/:id',
            name: 'report_edit',
            component: () => import('@cc/clients/reports/NewDealPerformanceReport.vue'),
            meta: {
                title: 'New deal performance report',
                dest_for: 'report',
                resource: 'Settings',
                action: 'create_report',
                module: 'project'
            }
        },
        {
            path: '/project/reports/new-deal-performance',
            name: 'new_deal_performance',
            component: () => import('@cc/clients/reports/NewDealPerformanceReport.vue'),
            meta: {
                title: 'New deal performance report',
                dest_for: 'report',
                resource: 'Settings',
                action: 'create_report',
                module: 'project'
            }
        },
        {
            path: '/:module(project|crm)/staffing/edit/:id',
            name: 'staffing_edit',
            component: () => import('@cc/clients/reports/NewDealPerformanceReport.vue'),
            meta: {
                title: 'Staffing',
                dest_for: 'staffing',
                // resource: 'Settings',
                // action: 'create_report',
                // module: 'project'
            }
        },
        {
            path: '/:module(project|crm)/staffing/create',
            name: 'staffing_create',
            component: () => import('@cc/clients/reports/NewDealPerformanceReport.vue'),
            meta: {
                title: 'Staffing',
                dest_for: 'staffing',
                // resource: 'Settings',
                // action: 'create_report',
                // module: 'project'
            }
        },
        {
            path: '/:module(project|crm)/staffing',
            name: 'staffing',
            component: () => import('@cc/common/Staffing.vue'),
            meta: {
                title: 'Staffing',
                // resource: 'Settings',
                // action: 'view-users',
                // module: 'project',
            }
        },

        //Module: crm
        {
            path: '/crm/reports/report-pages',
            name: 'crm_report_pages',
            component: () => import('@cc/clients/reports/ReportPages.vue'),
            meta: {
                title: 'Report Pages',
                module: 'crm'
            }
        },
        {
            path: '/crm/reports/report-list',
            name: 'crm_report_list',
            component: () => import('@cc/clients/reports/ReportList.vue'),
            meta: {
                title: 'Report List',
                module: 'crm'
            }
        },
        {
            path: '/crm/reports/create',
            name: 'crm_report_create',
            component: () => import('@cc/clients/reports/NewDealPerformanceReport.vue'),
            meta: {
                title: 'Opportunity Report',
                dest_for: 'crm',
                // resource: 'Settings',
                // action: 'create_report',
                // module: 'project'
            }
        },
        {
            path: '/crm/reports/:id/edit',
            name: 'crm_report_edit',
            component: () => import('@cc/clients/reports/NewDealPerformanceReport.vue'),
            meta: {
                title: 'Opportunity Report',
                dest_for: 'crm',
                // resource: 'Settings',
                // action: 'create_report',
                // module: 'project'
            }
        },
        {
            path: '/crm/pipelines/:pipeline',
            name: 'pipeline_stages',
            component: () => import('@cc/modules/crm/PipelineStages.vue'),
            meta: {title: 'Pipeline Stages', module: 'crm'}
        },
        {
            path: '/crm/pipelines',
            name: 'pipelines',
            component: () => import('@cc/modules/crm/Pipelines.vue'),
            meta: {title: 'Pipelines', module: 'crm'}
        },
        {
            path: '/crm/settings',
            name: 'crm_settings',
            component: () => import('@cc/modules/crm/Settings.vue'),
            meta: {title: 'CRM Settings', module: 'crm'}
        },
        // replaced by v2
        // {
        //     path: '/crm/settings-form-gui',
        //     name: 'crm_settings_form_gui',
        //     component: () => import('@cc/modules/crm/FormSettingsGui.vue'),
        //     meta: {title: 'CRM Settings GUI', module: 'crm'}
        // },

        {
            path: '/:module(project|crm)/custom-settings-form-gui',
            name: 'crm_custom_settings_form_gui',
            component: () => import('@cc/modules/crm/custom-forms/CustomFormSettingsGui.vue'),
            meta: {
                title: 'Form Settings v2',
                module: 'crm',
                keepModalsOpen: true,
            }
        },

        {
            path: '/crm/lost-reason',
            name: 'crm_lost_reason',
            component: () => import('@cc/modules/crm/lost_reasons/LostReason.vue'),
            meta: {title: 'Lost Reasons', module: 'crm'}
        },
        {
            path: '/crm/opportunity-status',
            name: 'crm_opportunity_status',
            component: () => import('@cc/modules/crm/opportunity_status/OpportunityStatus.vue'),
            meta: {title: 'Opportunities Status', module: 'crm'}
        },
        // {
        //     path: '/crm/company',
        //     name: 'company',
        //     component: () => import('@cc/modules/crm/company/Companies.vue'),
        //     meta: {title: 'Companies', module: 'crm'}
        // },
        // {
        //     path: '/crm/company/details/:id',
        //     name: 'crm_company_details',
        //     component: () => import('@cc/modules/crm/company/CompanyOverview.vue'),
        //     meta: {title: 'Company Overview', module: 'crm'}
        // },
        {
            path: '/crm/company/create',
            name: 'crm_company_create',
            component: () => import('@cc/clients/companies/CompanyCreate.vue'),
            meta: {title: 'Create Company', module: 'crm'}
        },
        {
            path: '/crm/company/edit/:id',
            name: 'crm_company_edit',
            component: () => import('@cc/clients/companies/CompanyCreate.vue'),
            meta: {title: 'Edit Company', module: 'crm'}
        },
        {
            path: '/crm/opportunities/:mode(card|card-min|list)?',
            name: 'crm_opportunities',
            component: () => import('@cc/modules/crm/Opportunities.vue'),
            meta: {title: 'Opportunities', module: 'crm'}
        },
        {
            path: '/crm/opportunities/import',
            name: 'crm_opportunities_import',
            component: () => import('@cc/modules/crm/OpportunityImport.vue'),
            meta: {title: 'Import Opportunities', module: 'crm'}
        },
        {
            path: '/crm/opportunities/details/:id',
            name: 'crm_opportunity_details',
            component: () => import('@cc/modules/crm/opportunities/OpportunityDetails.vue'),
            meta: {title: 'Opportunity Details', module: 'crm'}
        },

        {
            path: '/crm/opportunities/details/:id/:activity',
            name: 'crm_opportunity_details_activity',
            component: () => import('@cc/modules/crm/opportunities/OpportunityDetails.vue'),
            meta: {title: 'Opportunity Details', module: 'crm'}
        },
        {
            path: '/crm/people',
            name: 'crm_people',
            component: () => import('@cc/modules/crm/company/People.vue'),
            meta: {title: 'People', module: 'crm'}
        },

        // crm presets

        {
            path: '/crm/form-section/:category',
            name: 'formsection',
            component: () => import('@cc/modules/crm/presets/FormSections.vue'),
            meta: {title: 'FormSections', module: 'crm'}
        },
        {
            path: '/crm/form-categories/',
            name: 'form_categories',
            component: () => import('@cc/modules/crm/presets/FormCategories.vue'),
            meta: {title: 'Form Categories', module: 'crm'}
        },


        // {
        //     path: '/crm/opportunity',
        //     name: 'opportunity',
        //     component: () => import('@cc/modules/crm/Opportunities.vue'),
        //     meta: {title: 'Opportunity', module: 'crm'}
        // },

        {
            path: '/:module(project|crm)/home',
            name: 'home',
            component: () => import('@cc/ProjectHome.vue'),
            meta: {title: 'Home'}
        },

        // ------  bespoke table

        {
            path: '/project/bespoke-table',
            name: 'bespoke_table',
            component: () => import('@cc/bespoke_tables/BespokeTable.vue'),
            meta: {title: 'Bespoke Table', module: 'project'}
        },
        {
            path: '/project/bespoke-table-column/:table',
            name: 'bespoke_table_column',
            component: () => import('@cc/bespoke_tables/BespokeTableColumn.vue'),
            meta: {title: 'Bespoke Table Column Name', module: 'project'}
        },

        {
            path: '/project/bespoke-table-list',
            name: 'bespoke_table_list',
            component: () => import('@cc/bespoke_tables/MyBespokeTable.vue'),
            meta: {title: 'Bespoke Table', module: 'project'}
        },
        {
            path: '/project/my-bespoke-table/:table',
            name: 'my_bespoke_table',
            component: () => import('@cc/bespoke_tables/MyBespokeTableColumn.vue'),
            meta: {title: 'Bespoke Table', module: 'project'}
        },
        // --------------
        {
            path: '/crm/opportunities/tracker/:wide',
            name: 'opportunity_tracker',
            component: () => import('@cc/modules/crm/opportunity_tracker/OpportunityTracker.vue'),
            meta: {title: 'Opportunities Tracker Group', module: 'crm'}
        },
        {
            path: '/crm/opportunities/tracker-group/:tracker',
            name: 'opportunity_tracker_group',
            component: () => import('@cc/modules/crm/opportunity_tracker/OpportunityTrackerGroup.vue'),
            meta: {title: 'Opportunities Tracker Group', module: 'crm'}
        },
        // finder-----
        {
            path: '/:module(project|crm)/finder/company',
            name: 'company_finder',
            component: () => import('@cc/clients/finder/CompanyFinder.vue'),
            meta: {title: 'Company Finder',}
        },
        {
            path: '/:module(project|crm)/finder/person',
            name: 'person_finder',
            component: () => import('@cc/clients/finder/PersonFinder.vue'),
            meta: {title: 'Person Finder',}
        },
        // company financial
        {
            path: '/:module(project|crm)/company-financials',
            name: 'company_financials',
            component: () => import('@cc/clients/company_financials/CompanyFinancial.vue'),
            meta: {title: 'Company Financials'}
        },
        {
            path: '/:module(project|crm)/eu-company-financials',
            name: 'eu_financials',
            component: () => import('@cc/clients/company_financials/EUFinancial.vue'),
            meta: {title: 'EU Company Financials'}
        },
        // activities
        {
            path: '/:module(project|crm)/activities',
            name: 'activities',
            component: () => import('@cc/clients/companies/Activities.vue'),
            meta: {title: 'Activities', module: 'project'}
        },
        {
            path: '/:module(project|crm)/note-titles',
            name: 'note_titles',
            component: () => import('@cc/common/note/NoteTitles.vue'),
            meta: {title: 'Note Titles', module: 'crm'}
        },

        // dac
        {
            path: '/:module(project|crm)/dac/setup',
            name: 'dac_setup',
            component: () => import('@cc/clients/deal_approval_committee/DacSetupCreate.vue'),
            meta: {
                title: 'DAC Setup',
                dest_for: 'dac_setup',
                resource: 'DAC Approval Committee',
                action: 'dac_setup'
            }
        },
        {
            path: '/:module(project|crm)/dac/submission',
            name: 'dac_submission',
            component: () => import('@cc/clients/deal_approval_committee/DacSubmission.vue'),
            meta: {
                title: 'DAC Submission',
                dest_for: 'dac_submission',
                resource: 'DAC Approval Committee',
                action: 'dac_submission'
            }
        },
        {
            path: '/:module(project|crm)/dac/submission-centre',
            name: 'dac_submission_centre',
            component: () => import('@cc/clients/deal_approval_committee/DacSubmissionCentre.vue'),
            meta: {title: 'DAC Approval Centre'}
        },
        {
            path: '/:module(project|crm)/company-informations',
            name: 'company_information',
            component: () => import('@cc/clients/finder/CompanyInformation.vue'),
            meta: {title: 'Company Information'}
        },
        {
            path: '/:module(project|crm)/company-maps',
            name: 'compnay_maps',
            component: () => import('@cc/clients/companies/CompanyMaps.vue'),
            meta: {title: 'Company Maps'}
        },
        {
            path: '/:module(project|crm)/forms/resource-tabs/:resource',
            name: 'resource_tabs',
            component: () => import('@cc/modules/crm/custom-forms/ResourceTabs.vue'),
            meta: {
                title: 'Resource Tabs',
            }
        },
        {
            path: '/:module(project|crm)/forms/resource-tab-layouts/:resource/:tab',
            name: 'resource_tab_layouts',
            component: () => import('@cc/modules/crm/custom-forms/ResourceTabLayouts.vue'),
            meta: {
                title: 'Resource Tab Forms',
            }
        },
        {
            path: '/:module(project|crm)/my-schedules',
            name: 'my_schedule',
            component: () => import('@cc/split/EmailSchedules.vue'),
            meta: {
                title: 'My Email Schedules',
            }
        },

        {
            path: '/:module(project|crm)/credentials',
            name: 'credentials',
            component: () => import('@cc/common/credentials/Credentials.vue'),
            meta: {
                title: 'Credentials Manager',
            }
        },
        {
            path: '/:module(project|crm)/data-export-schedules',
            name: 'data_export_schedules',
            component: () => import('@cc/clients/data_export/DataExportScheduleSettings.vue'),
            meta: {
                title: 'Data Export Schedules',
            }
        },
        // {
        //     path: '/:module(project|crm)/contact-tags',
        //     name: 'contact_tags',
        //     component: () => import('@cc/modules/crm/contact_tags/ContactTags.vue'),
        //     meta: {
        //         title: 'Contact Tags',
        //     }
        // },
        // {
        //     path: '/:module(project|crm)/pdf-viewer/',
        //     name: 'pdf_viewer',
        //     component: () => import('@cc/clients/companies/PdfViewer.vue'),
        //     meta: {title: 'PDF Viewer', module: 'project'},
        //     props: route => ({ url: route.query.url }),
        // },
        //Catch All Common
        {path: '/', name: 'home', component: () => import('@cc/Home.vue')},
        {path: '/:module?', name: 'module_dash', component: () => import('@cc/Home.vue')}, // catches /app/project and /app/project/
        {path: '*', component: () => import('@cc/NotFound.vue'), meta: {title: 'Not Found'}}
    ]
})

router.beforeEach((to, from, next) => {
    if(to.meta.authExempt){
        return next()
    }

    if(!Vue.prototype.$isAuth){
        return next({name: 'login'})
    }

    // kill all dynamic modals
    if (!to.meta.keepModalsOpen && Vue.prototype.$modal) {
        Vue.prototype.$modal.hideAll();
    }

    //KTM cleanup, release RAM
    // router.app.$killKTMStore()

    const modules = router.app.$modules // client's modules
    const module = to.meta.module // target page's module
    const module_ = to.params.module // target page's module
    if (module && !Vue.prototype.$hasModuleAccess(module)) {
        // route meta module does not exist on client's module list
        return next({
            name: '403'
        })
    }

    if (to.meta.resource && to.meta.action && !Vue.prototype.$hasPermission(to.meta.resource, to.meta.action)) {
        return next({
            name: '403',
            params: {
                module: module_,
            },
            query: {
                xpath: to.path,
            }
        })
    }

    return next()
})

const DEFAULT_TITLE = 'ROCLO';
router.afterEach((to, from) => {
    // per route new correlation id
    window.x_correlation_id = uuidv4()

    // clear Sentry breadcrumbs on route change
    Sentry.configureScope(scope => scope.clear());

    // https://github.com/vuejs/vue-router/issues/914#issuecomment-384477609
    Vue.nextTick(() => {
        document.title = to.meta.title || DEFAULT_TITLE;
    });
});

export default router